import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const EmptyBlocks = ({ className }: SVGProps) => {
  return (
    <svg
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      focusable="false"
      aria-hidden="true"
      width="200px"
      height="200px"
    >
      <path
        opacity=".2"
        d="M188.982 97.3708c1.07 45.2732-45.17 85.2982-88.353 84.6212-44.924-.705-95.55846-37.394-89.063-94.4833 5.7155-50.2339 35.3198-68.0034 85.1861-69.4651 49.8659-1.4618 91.1589 34.0542 92.2299 79.3272Z"
        fill="#8FAAC7"
      />
      <path
        d="M48 64.7143V54c0-3.3137 2.6863-6 6-6h10.7143M152 135.286V146c0 3.314-2.686 6-6 6h-10.714"
        stroke="#333"
        strokeWidth="2"
      />
      <path
        stroke="#D80C86"
        strokeWidth="2"
        strokeLinecap="round"
        d="M163 67.2h10M167.8 62v10"
      />
      <path
        stroke="#12B4D9"
        strokeWidth="2"
        strokeLinecap="round"
        d="M75 40h6M78 37v6"
      />
      <path
        stroke="#0FCE72"
        strokeWidth="2"
        strokeLinecap="round"
        d="M95 28h8M99 24v8"
      />
      <rect
        x="92.6162"
        y="57"
        width="50.3838"
        height="39.3404"
        rx="3"
        fill="#96E1F3"
      />
      <rect
        x="57"
        y="57"
        width="27.798"
        height="21.0426"
        rx="3"
        fill="#12B4D9"
      />
      <rect
        x="57"
        y="85.3617"
        width="27.4468"
        height="10.9787"
        rx="3"
        fill="#37BFA7"
      />
      <rect
        x="108.253"
        y="143"
        width="51.2525"
        height="39.3404"
        rx="3"
        transform="rotate(-180 108.253 143)"
        fill="#A687FE"
      />
      <rect
        x="143"
        y="143"
        width="27.798"
        height="39.3404"
        rx="3"
        transform="rotate(-180 143 143)"
        fill="#FFD980"
      />
    </svg>
  );
};
